import React from 'react';
import { whyIndotravelista } from '../data/mock';
import { CheckCircle } from 'lucide-react';

export const WhyIndotravelista = () => {
  return (
    <section className="section-padding" style={{ background: 'var(--bg-secondary)' }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '80px' }}>
          <h2 className="hero-medium" style={{ marginBottom: '16px' }}>
            Why Travel with Indotravelista?
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            We don&apos;t just transport travelers from one destination to another. We create journeys that reveal Indonesia&apos;s stories, culture, and spirit.
          </p>
        </div>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: '32px'
        }}>
          {whyIndotravelista.map((item, index) => (
            <div
              key={`why-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
              style={{
                background: 'var(--bg-primary)',
                padding: '40px 32px',
                borderRadius: 0,
                transition: 'transform 0.2s ease, box-shadow 0.2s ease'
              }}
              className="hover-lift"
            >
              <div style={{
                width: '48px',
                height: '48px',
                background: 'var(--bg-secondary)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: '24px',
                borderRadius: 0
              }}>
                <CheckCircle size={24} color="var(--text-primary)" />
              </div>
              <h3 className="heading-3" style={{ marginBottom: '12px' }}>
                {item.title}
              </h3>
              <p className="body-regular" style={{ 
                color: 'var(--text-secondary)',
                lineHeight: 1.6
              }}>
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
